// extracted by css-extract-rspack-plugin
export default {"clickable":"uATQH3","spacer":"d3YmLJ","slider":"rDgxTe","markers":"zVJedf"};